import React, { useState, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'

import text from '../constants/Login'

import '../styles/containers/SendResetPasswordEmail.css'
import LoginHeader from '../components/LoginHeader'
import FormButton from '../components/FormButton'
import FormInput from '../components/FormInput'
import API from '../services/Api'
import { toast } from 'react-toastify'
import LoginBackButton from '../components/LoginBackButton'
import useLanguage from '../hooks/useLanguage'

const SendResetPasswordEmail = () => {
  const history = useHistory()

  const language = useLanguage()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [emailSent, setEmailSent] = useState(false)

  const requestSendResetPasswordEmail = async e => {
    e.preventDefault()

    setLoading(true)

    try {
      await API.sendResetPasswordEmail(email)
      setEmailSent(true)
      toast.success(text.recovery[language])
    } catch (err) {
      console.error(err)
      if (err.errorMessage) {
        setError(err.errorMessage)
      }
    }

    setLoading(false)
  }

  return (
    <div className='sendpasswordemail-screen-container'>
      <LoginHeader />
      <form className='sendpasswordemail-screen-form'>
        <LoginBackButton onClick={history.goBack} />
        <p className='sendpasswordemail-screen-title'>{text.forgot[language]}</p>
        {emailSent ? (
          <Fragment>
            <p className='sendpasswordemail-screen-subtitle sendpasswordemail-sent'>{text.recovery[language]}<br />{text.recoverySpam[language]}</p>
          </Fragment>
        ) : (
          <Fragment>
            <p className='sendpasswordemail-screen-subtitle'>{text.sendResetPasswordEmail[language]}</p>
            <FormInput className='sendpasswordemail-screen-input' placeholder={text.email[language]} value={email}
              onChange={e => setEmail(e.target.value)} />
            {error !== null && <p className='sendpasswordemail-screen-error'><strong>{error}</strong></p>}
            <FormButton className='sendpasswordemail-screen-button'
              loading={loading} onClick={requestSendResetPasswordEmail}>
              {text.redefinePassword[language]}
            </FormButton>
          </Fragment>
        )}
        <FormButton onClick={history.goBack} type='button'
          className='sendpasswordemail-back-button sendpasswordemail-screen-button'>
          {text.back[language]}
        </FormButton>
      </form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(SendResetPasswordEmail)



// WEBPACK FOOTER //
// ./src/containers/SendResetPasswordEmail.js